export default __webpack_public_path__ + "static/media/app7-slider-woman.45d4279c.png";